import React from 'react';
import { Box, Grid, Paper } from '@mui/material';
import AdminSidebar from './AdminSidebar';

function AdminLayout({ children }) {
  return (
    <Box>
      <Grid container spacing={3}>
        <Grid item xs={12} md={3}>
          <Paper sx={{ p: 2 }}>
            <AdminSidebar />
          </Paper>
        </Grid>
        <Grid item xs={12} md={9}>
          {children}
        </Grid>
      </Grid>
    </Box>
  );
}

export default AdminLayout;